import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateCurriculumRequirementForm from "../../forms/CreateOrUpdateCurriculumRequirementForm";

interface CreateCurriculumRequirementModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateCurriculumRequirementModal: React.FC<
  CreateCurriculumRequirementModalProps
> = ({ open, onClose, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="New Curriculum Requirement"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateCurriculumRequirementForm loading={loading} error={error} />
  </AppModal>
);

export default CreateCurriculumRequirementModal;
